module.exports = __webpack_public_path__ + "img/join-the-directory.6331105d.jpg";